import React, { useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import JsBarcode from "jsbarcode";
import "./BarcodePrint.css";
import { Box, Button, Typography } from '@mui/material';

const LandDocBarcode = () => {
  const barcodeRef = useRef();
  const [searchParams] = useSearchParams();
  const parcelCode = searchParams.get("parcelCode") || "";
  const oldParcel = searchParams.get("oldParcel") || "";

  useEffect(() => {
    if (barcodeRef.current && parcelCode) {
      JsBarcode(barcodeRef.current, parcelCode, {
        format: "CODE128",
        width: 2.5,         // 🟢 ปรับความกว้างเส้นบาร์โค้ดให้พอดีกับ 4 นิ้ว
        height: 45,        // 🟢 ความสูงบาร์โค้ด
        displayValue: true, // แสดงตัวเลข parcelCode ใต้บาร์โค้ด
        fontSize: 14,
        margin: 2
      });
    }
  }, [parcelCode]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box textAlign="center" p={3}>
      {/* 📦 พื้นที่สติ๊กเกอร์สำหรับสั่งพิมพ์ */}
      <Box className="print-area">
        <div id="print-area">
          <div className="sticker-box">
            {/* เลขแปลงเก่า (ตัวโตชัดเจน) */}
            <Typography
              sx={{
                fontSize: "32px", // 🟢 กำหนดขนาดตัวอักษรให้พอดีกับพื้นที่ 1.5 นิ้ว
                fontWeight: "bold",
                lineHeight: 1.1,
                color: "black",
                fontFamily: "monospace"
              }}
            >
              {oldParcel || "-"}
            </Typography>

            {/* บาร์โค้ด SVG */}
            <svg ref={barcodeRef} style={{ maxWidth: "95%", height: "auto" }} />
          </div>
        </div>
      </Box>

      {/* 🖨️ ปุ่มสั่งพิมพ์ (ซ่อนอัตโนมัติเมื่อสั่งพิมพ์) */}
      <Button
        variant="contained"
        color="primary"
        onClick={handlePrint}
        sx={{ mt: 3 }}
        className="print-hidden"
      >
        🖨️ พิมพ์สติ๊กเกอร์ติดซอง
      </Button>
    </Box>
  );
};

export default LandDocBarcode;